import { combineReducers } from '@reduxjs/toolkit';

import currenciesReducer from './payment-options-currencies';
import gatewayReducer from './payment-options-gateways';
import merchantsReducer from './payment-options-merchants';
import methodsReducer from './payment-options-methods';
import platformsReducer from './payment-options-platforms';
import tabsReducer from './payment-options-tabs';
import propertyKeysReducer from './payment-options-property-keys';
import contextualMessageReducer from './payment-options-contextual-messages';
import maintenanceRulesReducer from './payment-options-maintenance-rules';
import methodMatrixReducer from './payment-options-method-matrix';
import processingFeesReducer from './payment-options-processing-fees';

const reducer = combineReducers({
  currencies: currenciesReducer,
  gateways: gatewayReducer,
  merchants: merchantsReducer,
  methods: methodsReducer,
  platforms: platformsReducer,
  propertyKeys: propertyKeysReducer,
  tabs: tabsReducer,
  contextualMessage: contextualMessageReducer,
  maintenanceRules: maintenanceRulesReducer,
  methodMatrix: methodMatrixReducer,
  processingFees: processingFeesReducer,
});
export default reducer;
